import { type MouseEvent } from 'react';

interface CloseIconProps {
  className?: string;
  onClick: (e: MouseEvent<SVGSVGElement>) => void;
}

export const CloseIcon = (props: CloseIconProps) => {
  return (
    <svg className={props.className} onClick={props.onClick} xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-4 -4 20 20'>
      <path
        fill='currentColor'
        d='M4.732 6.354L.49 2.11 1.904.697l4.242 4.242L10.39.697l1.414 1.414-4.242 4.243 4.242 4.242-1.414 1.414-4.243-4.242-4.242 4.242L.49 10.596l4.242-4.242z'
      />
    </svg>
  );
};
